module.exports = __webpack_public_path__ + "img/support.f7e25f25.svg";